import { useState } from "react";

type ValidationErrors = Record<string, string[]>;

interface UseValidationErrors {
	errors: ValidationErrors;
	setErrors: (errors: ValidationErrors | ((prev: ValidationErrors) => ValidationErrors)) => void;
	clearErrors: () => void;
	getFirstError: (field: string) => string | undefined;
}

export function useValidationErrors(): UseValidationErrors {
	const [errors, setErrors] = useState<ValidationErrors>({});

	const clearErrors = () => {
		setErrors({});
	};

	const getFirstError = (field: string): string | undefined => {
		return errors[field]?.[0];
	};

	return {
		errors,
		setErrors,
		clearErrors,
		getFirstError,
	};
}

// Legacy function for backward compatibility
type Errors = string[];
type SetErrorFn = (err: Record<string, string[]>) => void;
type ClearErrorFn = () => void;
type GetFirstErrorFn = () => string | false;

export function useValidationError(): [Errors, SetErrorFn, ClearErrorFn, GetFirstErrorFn] {
	const [errors, setErrors] = useState<Errors>([]);

	const setErrorFn: SetErrorFn = (err) => {
		const newErrors = [];

		for (const key in err) {
			// biome-ignore lint/suspicious/noPrototypeBuiltins: <explanation>
			if (err.hasOwnProperty(key)) {
				newErrors.push(err[key][0]);
			}
		}

		setErrors(newErrors);
	};

	const clearErrorFn: ClearErrorFn = () => {
		setErrors([]);
	};

	//returns first error
	const getFirstError: GetFirstErrorFn = () => {
		if (errors.length) {
			return errors[0];
		}

		return false;
	};

	return [errors, setErrorFn, clearErrorFn, getFirstError];
}
